import { Injectable } from '@angular/core';

import { Subject } from "rxjs";

import { SharedModule } from '@shared/shared.module';

@Injectable({
  providedIn: SharedModule
})
export class CustomEventService {
  // Observable data sources
  private announcedSource = new Subject<any>();

  // Observable data streams that components are subscribed to
  eventAnnounced$ = this.announcedSource.asObservable();

  // Service commands
  announceEvent(action: string, data?) {
    this.announcedSource.next({action, data});
  }
}
